import axios from "axios";

const globalUrl = "https://api.covid19api.com/summary";
// const localUrl = "https://api.covid19india.com";

export const fetchGlobalData = async () => {
  try {
    const response = axios.get(globalUrl);
    console.log(response.data);
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchCases = async (country) => {
  try {
    //https://api.covid19api.com/live/country/india/status/confirmed/date/2020-04-12T00:00:00Z
    const url = `https://api.covid19api.com/total/dayone/country/${country}`;
    const response = axios.get(url);
    return response;
  } catch (error) {
    return error;
  }
};
